export enum InterpolationType {
    NO_INTERPOLATION = 11,
    NEAREST_NEIGHBOR = 0,
    BI_LINEAR = 1,
    BI_QUADRATIC = 2,
    BI_CUBIC = 3,
    BI_QUARTIC = 4,
    BI_QUINTIC = 5
}
